export default __webpack_public_path__ + "static/media/travel.60a8c217.png";